<template>
  <div v-if="isDraft" class="draft-name-cell">
    <feather-icon icon="CornerDownRightIcon" svgClasses="h-4 w-4" class="draft-name-cell__icon"/>
    <span class="draft-name-cell__name">{{ name }}</span>
    <span class="draft-name-cell__status">draft in progress</span>
  </div>
  <span v-else>{{ name }}</span>
</template>

<script>
export default {
  name: 'CertificationNameCell',
  props: {
    name: {
      type: String,
      default: '',
    },
    isDraft: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.draft-name-cell {
  align-items: center;

  display: flex;
  gap: 6px;
}

.draft-name-cell__icon {
  color: rgb(209, 213, 219);
}

.draft-name-cell__name {
  font-style: italic;
  font-size: 13px;
}

.draft-name-cell__status {
  font-size: 10px;
  background-color: rgb(254, 243, 199);
  color: rgb(146, 64, 14);
  border: 1px solid rgb(252, 211, 77);
  border-radius: 3px;
  padding: 1px 6px;
  font-style: normal;
}
</style>
